import { resourceText } from 'src/app/shared/services/localization';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../account/auth.service';
import { Location } from '@angular/common';
import { User } from '../account/user.model';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit, AfterViewInit {
  householdSetup = false;
  confirmDeletion = false;
  deletingAccount = false;
  accountDeleted = false;
  deletionError = '';
  async deleteAccount() {
    if (this.deletingAccount) return;
    this.deletingAccount = true; this.deletionError = '';
    try {
      await this.profileService.unsubscribe(this.userId);
      localStorage.removeItem('CSBarcodeID');
      this.authService.logout(0);
      this.globalService.currentUserId = null;
      this.globalService.fromRegistration = false;
      this.confirmDeletion = false; this.accountDeleted = true;
      await this._router.navigate(['/' + this.tenantService.getTenant() + '/home'], {
        replaceUrl: true, state: { accountDeleted: true }
      });
    } catch {
      this.deletionError = 'We could not finish deleting your account. Please try again. Your account has not been marked as deleted.';
    } finally { this.deletingAccount = false; }
  }
  User: User = null;
  userId: string = null;
  constructor(
    public profileService: ProfileService,
    private authService: AuthService,
    private _router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private tenantService: TenantService,
    private _location: Location
  ) {}

  goHome() {
    this.globalService.fromRegistration = false;
    this._router.navigate(['/' + this.tenantService.getTenant() + '/home']);
  }

  async ngOnInit() {

    this.householdSetup = this.route.snapshot.queryParamMap.get('setup') === 'household';
    this.globalService.isBack = false;
    this.userId = this.globalService.currentUserId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "MYPROFILE";    
    this.globalService.screenHeader = resourceText('MY_PROFILE_HOUSEHOLD');
    });
  }         
}
